require('./confirmMailController.js')
require('./loginPageController.js')
require('./signupPageController.js')
